<div class="search-container" [class.with-selector]="searchTypeOptions?.length">
  @if (searchTypeOptions?.length) {
    <mat-form-field
      class="search-type-selector"
      subscriptSizing="dynamic"
      >
      @if (searchTypeControl.value) {
        <span class="prefix" matPrefix>By: </span>
      }
      <mat-select
        [formControl]="searchTypeControl"
        class="type-select"
        placeholder="By"
        [panelWidth]="null"
        >
        @for (option of searchTypeOptions; track option.id) {
          <mat-option [value]="option.id">
            {{ option.displayName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  <mat-form-field subscriptSizing="dynamic" class="search-input-field">
    <mat-label>{{ placeholder }}</mat-label>
    <input matInput type="text" [formControl]="filterControl" />
    @if (filterControl.value) {
      <button
        mat-icon-button
        matSuffix
        aria-label="Clear"
        (click)="onClearFilter()"
        >
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
</div>
